module.exports = __webpack_public_path__ + "img/template_story_nextplz.d588d02e.png";